import { BadgeCheck, ShieldCheck, Award, HeartHandshake, Share2 } from "lucide-react";
import { useLang } from "@/context/AppContext";

const BADGES = {
  verified: [BadgeCheck, "text-emerald-300 border-emerald-400/40"],
  trusted: [ShieldCheck, "text-yellow-300 border-yellow-400/40"],
  proven: [Award, "text-cyan-300 border-cyan-400/40"],
  reliable: [HeartHandshake, "text-rose-300 border-rose-400/40"],
  connector: [Share2, "text-slate-200 border-slate-400/40"],
};

export const TrustBadge = ({ badge }) => {
  const { t } = useLang();
  const [Icon, tone] = BADGES[badge] || BADGES.connector;
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 font-mono text-[10px] uppercase tracking-widest ${tone}`} data-testid={`badge-${badge}`}>
      <Icon className="h-3.5 w-3.5" />{t(`b_${badge}`)}
    </span>
  );
};

export const TrustRing = ({ value, size = 72 }) => {
  const r = size / 2 - 5;
  const c = 2 * Math.PI * r;
  return (
    <div className="relative" style={{ width: size, height: size }} data-testid="trust-ring">
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} stroke="rgba(255,255,255,0.08)" strokeWidth="4" fill="none" />
        <circle cx={size / 2} cy={size / 2} r={r} stroke="#10B981" strokeWidth="4" fill="none" strokeLinecap="round" strokeDasharray={c} strokeDashoffset={c * (1 - value / 100)} className="transition-all duration-700" />
      </svg>
      <span className="absolute inset-0 grid place-items-center font-display text-xl font-bold text-white">{value}</span>
    </div>
  );
};
